import type { AlbumTypeEnum } from './album-add.interface';
import type { FileAndTypeInterface } from './attachFiles.interface';
import type { KeywordInterface } from './keyword.interface';
import type { Study } from './study.interface';

export enum AlbumCaseTypeEnum {
  PATHOLOGIQUE = 'PATHOLOGIQUE',
  PHYSIOLOGIQUE = 'PHYSIOLOGIQUE'
}

export interface AlbumWithCaseInterface {
  id: number;
  name: string;
  createdAt: Date;
  type: AlbumTypeEnum;
  nbCases: number;
  cases: AlbumCaseInterface[];
}

export interface AlbumCaseInterface {
  id: number;
  name: string;
  createdAt: Date;
  type: AlbumCaseTypeEnum;
  nbAttachments: number;
  study: Study;
  keywords: KeywordInterface[];
  albumId: number;
}

export interface AlbumCaseModifyInterface {
  name: string;
  type: AlbumCaseTypeEnum;
}

export interface AlbumCaseUpdateInterface {
  id: number;
  name: string;
  type: AlbumCaseTypeEnum;
  fileTypes: FileAndTypeInterface[];
}
